const themeShape = {
  borderRadius: 5,
}
export default themeShape
